(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('filenew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="filenew-component" data-hook="filenew-component">
        <h3>Neue/s file anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addFile()" ng-hide="vm.newfile">Neue/s file anlegen</div>
        <div ng-show="vm.newfile">
          <fileform file="vm.newfile" parentsave="vm.saveNewFile(file)" oncancel="vm.cancel()"></fileform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> file erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen file wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> file konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'File', 'Rlog',
        function ($log, File, Rlog) {
          let vm = this;
          vm.addFile = addFile;
          vm.saveNewFile = saveNewFile;
          vm.cancel = cancel;
          
          function addFile() {
            vm.newfile = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewFile(file) {
            $log.debug('debug: create new file: ', file);
            delete vm.newfile;
            File.$create(file).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new file failed: ', err);
              Rlog.error('vcutils.file', 'filenew', 'Creation of new file failed: ', {file: vm.newfile});
            });
          }
          
          function cancel() {
            delete vm.newfile;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
